import { showBackButtonForContent } from '@core/constants/backButtonNavigation';
import push from '../../utils/routing';

export default (spaceId, materialSectionId, queryParams) => () => {
  const baseUrl = materialSectionId
    ? `/dashboard/${spaceId}/journey/educatorArea/${materialSectionId}`
    : `/dashboard/${spaceId}/journey/educatorArea`;

  // QUICK FIX : This logic ensures that we maintain proper back navigation behavior.This will check if there are any query parameters to be appended.
  // If not, it will check the existing URL for any "from" parameters to maintain navigation context.
  const { showBackbutton, queryParams: backParams } =
    showBackButtonForContent();
  const finalQuery = queryParams ?? (showBackbutton ? backParams : undefined);

  push({
    pathname: baseUrl,
    ...(finalQuery ? { query: finalQuery } : {}),
  });
};
